export const BUSINESS = {
  brand: "Velvet Touch",
  therapist: "Mahogany",
  phoneDisplay: "+1 (346) 761-8943",
  phoneHref: "tel:+13467618943",
  whatsappHref:
    "https://wa.me/13467618943?text=Hi%20Mahogany%2C%20I%27d%20like%20to%20book%20a%20session.",
  whatsappOilHref:
    "https://wa.me/13467618943?text=Hi%20Mahogany%2C%20I%27d%20like%20to%20order%20the%20Hemp%20Body%20Oil.",
  whatsappGiftHref:
    "https://wa.me/13467618943?text=Hi%20Mahogany%2C%20I%27d%20like%20to%20gift%20a%20session%20to%20someone.",
  email: "themochalatte@proton.me",
  emailHref: "mailto:themochalatte@proton.me",
  city: "Houston",
};

export const IMAGES = {
  hero: "/images/new2.webp",
  oilPour: "https://images.pexels.com/photos/9268041/pexels-photo-9268041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hotOil:
    "https://images.pexels.com/photos/8312837/pexels-photo-8312837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  nuru: "https://images.pexels.com/photos/10600171/pexels-photo-10600171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  incall: "/images/table.jpg",
  experience:
    "https://images.pexels.com/photos/31373771/pexels-photo-31373771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portrait: "/images/mahogany.webp",
  portraitAlt: "/images/g8.webp",
  portraitBraids: "/images/new1.jpeg",
};

export const SERVICES = [
  {
    id: "hot-oil",
    name: "The Mocha Melt",
    sub: "Hot Oil Full Body",
    price: "$145",
    duration: "60 min",
    image: IMAGES.hotOil,
    imageAlt: "A client enjoying a calming hot oil massage therapy session",
    description:
      "Slow, rhythmic strokes with heated premium oils to dissolve deep-seated tension and awaken total sensory serenity.",
    tag: null,
  },
  {
    id: "nuru",
    name: "Melted Butter Friction Massage",
    price: "$180",
    duration: "60 min",
    image: IMAGES.nuru,
    imageAlt: "A client relaxed during a smooth, gliding massage ritual",
    description:
      "The signature Velvet Touch ritual — warm, silky nuru gel and long, gliding full-body strokes for deep, weightless relaxation.",
    tag: "Signature",
  },
  {
    id: "incall",
    name: "Dedicated Time & Hand Massage",
    price: "$215",
    duration: "60 min",
    image: IMAGES.incall,
    imageAlt: "Mahogany's professional massage table, premium oils and fresh setup",
    description:
      "The complete sanctuary experience in a discreet, private setting — full 60 minutes, unhurried, tailored entirely to you.",
    tag: null,
  },
];

export const TREATMENT_OPTIONS = [
  "The Mocha Melt (Hot Oil Full Body) — $145 (60 min)",
  "Melted Butter Friction Massage — $180 (60 min)",
  "Dedicated Time & Hand Massage — $215 (60 min)",
  "Deep Tissue / Therapeutic Massage",
  "Hemp Oil Massage",
  "Outcall / Mobile Session",
];

export const MARQUEE_ITEMS = [
  "Licensed Massage Therapist",
  "Complete Discretion",
  "Luxurious Outcall Service",
  "Se Habla Español",
  "Hot Oil & Nuru Rituals",
  "Morning Appointments",
  "Hot Towel Finishes",
  "Hemp Body Oil For Sale",
  "The Mocha Experience",
];
